import React from 'react';
import { ArrowLeft, Shield, Scan, Camera, MapPin, Star, Lock } from 'lucide-react';
import DoodleBackground from '../components/DoodleBackground';

const Safety = () => {
  return (
    <div>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        background: 'rgba(255,255,255,.97)', boxShadow: '0 2px 20px rgba(120,81,169,.08)',
        backdropFilter: 'blur(16px)', padding: '10px 0',
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none', color: 'inherit' }}>
            <img src="/logo.png" alt="Spee'V'Dee" style={{ width: 44, height: 44, borderRadius: '50%' }} />
            <span className="logo-text"><span className="bk">Spee</span><span className="vv">'V'</span><span className="bk">Dee</span></span>
          </a>
          <a href="/" className="btn btn-outline" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: '#7851A9', fontWeight: 700, fontSize: 14, textDecoration: 'none', padding: '8px 20px', borderRadius: '50px', border: '2px solid #7851A9' }}>
            <ArrowLeft size={16} /> Back to Home
          </a>
        </div>
      </nav>

      <section style={{ background: '#f9fafb', position: 'relative', overflow: 'hidden', paddingTop: 100, paddingBottom: 80 }}>
        <DoodleBackground />
        <div style={{ maxWidth: 900, margin: '0 auto', padding: '0 24px', position: 'relative', zIndex: 1 }}>
          <div className="section-header">
            <span className="section-tag" style={{ background: 'rgba(120,81,169,.1)', color: '#7851A9' }}>SAFETY</span>
            <h2>Your Safety is Our Priority</h2>
            <p>Every delivery on Spee'V'Dee is protected by multiple layers of verification and security.</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20, marginBottom: 32 }}>
            {[
              { icon: <Shield size={28} color="#7851A9" />, title: 'Government ID Verification', desc: 'Every courier must submit a valid government-issued photo ID. Our AI-powered verification system cross-references against global databases to ensure authenticity.' },
              { icon: <Scan size={28} color="#7851A9" />, title: 'Facial Recognition', desc: 'Biometric facial scanning at registration and at every delivery checkpoint ensures the verified courier is the one handling your package. No substitutes, no impersonation.' },
              { icon: <Camera size={28} color="#7851A9" />, title: 'Package Photo Inspection', desc: 'Couriers photograph packages at pickup and delivery, creating a visual chain of custody. Any discrepancies are automatically flagged for review.' },
              { icon: <MapPin size={28} color="#7851A9" />, title: 'Real-Time GPS Tracking', desc: 'Track your package in real-time from pickup to delivery. Know exactly where your package is at all times with live map updates.' },
              { icon: <Star size={28} color="#7851A9" />, title: 'Two-Way Rating System', desc: 'Both senders and couriers rate each other after every delivery. Low-rated users are investigated and may be removed from the app.' },
              { icon: <Lock size={28} color="#7851A9" />, title: 'Secure Escrow Payments', desc: 'Payments are held in escrow until delivery is confirmed. Couriers only get paid after the sender confirms receipt. Your money is protected.' },
            ].map((item, i) => (
              <div key={i} style={{ background: '#fff', borderRadius: 14, padding: '28px 24px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                <div style={{ marginBottom: 12 }}>{item.icon}</div>
                <h4 style={{ fontSize: 16, fontWeight: 700, color: '#1F2937', marginBottom: 8 }}>{item.title}</h4>
                <p style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.7, margin: 0 }}>{item.desc}</p>
              </div>
            ))}
          </div>

          <div style={{ background: '#fff', borderRadius: 16, padding: '32px 36px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)', fontSize: 14, lineHeight: 1.8, color: '#374151' }}>
            <h3 style={{ color: '#7851A9', marginTop: 0 }}>Reporting Issues</h3>
            <p>If you experience any safety concerns, suspicious activity, or issues with a delivery, you can:</p>
            <ul style={{ paddingLeft: 24 }}>
              <li>Use the in-app <strong>"Report"</strong> button on any delivery or user profile</li>
              <li>Contact our 24/7 safety team at <strong>safety@speedyvariety.com</strong></li>
              <li>Chat with <strong>Zilee</strong>, our AI support assistant, available on every page</li>
              <li>For emergencies, always contact local law enforcement first</li>
            </ul>
            <p style={{ fontWeight: 600, color: '#7851A9' }}>We investigate all reports within 24 hours and take immediate action when necessary, including account suspension and law enforcement referral.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Safety;
